export const normalizeAmount = (value: string) =>
	value.replace(/\s+/g, '').toLowerCase();

export const parseLocaleNumber = (value: string): number =>
	parseFloat(value.replace(/\s/g, '').replace(',', '.'));

export const formatCurrency = (
	value: number | string | null | undefined
): string => {
	if (!value && value !== 0) return '';
	const numValue = typeof value === 'string' ? parseLocaleNumber(value) : value;
	if (Number.isNaN(numValue)) return '';
	const rounded = Math.round(numValue * 100) / 100;
	const stringValue = String(rounded);
	const [integerPart, decimalPart] = stringValue.split('.');
	const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	return decimalPart !== undefined
		? `${formattedInteger}.${decimalPart}`
		: formattedInteger;
};
